import {Base} from "@/api/Base"

export class AttendanceLogsList extends Base {
    path = "attendanceLogs/list"
}